import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function Modal({ open, onClose, title, subtitle, children, size = 'md', footer }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  if (!open) return null;
  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl',
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative card bg-white w-full ${sizes[size]} shadow-hard max-h-[90vh] flex flex-col fade-up`}>
        <div className="flex items-start justify-between border-b border-zinc-200 px-5 py-4">
          <div>
            {subtitle && <div className="overline mb-1">{subtitle}</div>}
            <div className="heading font-bold text-lg text-ink">{title}</div>
          </div>
          <button className="btn-ghost p-1.5" onClick={onClose} data-testid="modal-close">
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && <div className="border-t border-zinc-200 px-5 py-3 flex justify-end gap-2 bg-zinc-50">{footer}</div>}
      </div>
    </div>
  );
}
